module.exports = __webpack_public_path__ + "img/sad.11eb95ad.svg";